<template>
  <div>
    <pageTable/>
  </div>
</template>

<script>
import PageTable from './components/table';
export default {
  name: 'tc-scmOrder',
  components: {
    PageTable,
  },
}
</script>